import React, { useEffect, useState } from 'react';
import api from 'services/api';
import { PHONE_MASK } from 'v3/utils/masks';
import { Row, Col } from 'react-bootstrap';
import { Input, Select, Toggle } from 'v3/components';
import TextArea from 'v3/components/TextArea';
import { useAggregations } from './context';
import { fetchSelectOptions } from './controller';
import { personTypesOptions, activeStatusOptions, isVehicleTractionOptions } from './utils';

export default function Data() {
  const aggregation = useAggregations();
  const [vehicleTypes, setVehicleTypes] = useState();
  const [provinces, setProvinces] = useState();
  const [axisList, setAxisList] = useState();

  async function getVehicleAxis() {
    try {
      const { data } = await api.get('vehicle-axe?app=true');
      setAxisList(
        data.map((axis) => ({
          id: axis.id,
          name: axis.name,
        })),
      );
    } catch (ex) {
      setAxisList([{ name: 'Não encontrado.', id: 'null' }]);
    }
  }

  useEffect(() => {
    getVehicleAxis();
  }, []);

  function convertLookupToSelectArray(data) {
    try {
      const responseArray = [{ name: 'Todos', id: 'null' }];
      for (let i = 0; i < data.length; i += 1) {
        responseArray.push({ name: data[i].name, id: data[i].id });
      }
      return responseArray;
    } catch (ex) {
      return { name: 'Dados inconsistentes.', id: 'null' };
    }
  }

  async function getVehicleType() {
    try {
      const response = await api.get(`vehicle-types?app=${true}`);
      const convertedToSelectArray = convertLookupToSelectArray(response.data);
      setVehicleTypes(convertedToSelectArray);
    } catch (ex) {
      setVehicleTypes([{ name: 'Não encontrado.', id: 'null' }]);
    }
  }

  useEffect(() => {
    getVehicleType();
  }, []);

  async function getProvinces() {
    const response = await api.get('provinces');
    const provinceData = response.data.map((el) => ({
      ...el,
      label: el.name,
      value: el.id,
    }));
    setProvinces(provinceData);
  }

  useEffect(() => {
    getProvinces();
  }, []);

  return (
    <Row>
      <Col xs={12} className="mb-3">
        <Toggle
          label="Tipo de cadastro *"
          value={aggregation.data?.person_type}
          onSelected={(value) => aggregation.setData({ person_type: value })}
          options={personTypesOptions}
          error={aggregation.errors?.['data.person_type']}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Input
          label="Contato (email) *"
          type="email"
          value={aggregation.data?.contact_email}
          onChange={(event) => aggregation.setData({ contact_email: event.target.value })}
          error={aggregation.errors?.['data.contact_email']}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Input
          label="Telefone *"
          value={aggregation.data?.contact_phone}
          onChange={(event) => aggregation.setData({ contact_phone: event.target.value })}
          masked
          mask={PHONE_MASK}
          guide={false}
          error={aggregation.errors?.['data.contact_phone']}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Select
          label="Estado *"
          options={provinces}
          placeholder="Selecione um estado"
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={aggregation.data?.province}
          onChange={(value) => {
            aggregation.setData({ province: value });
            aggregation.setData({ province_id: value?.id });
          }}
          error={aggregation.errors?.['data.province_id']}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Select.Async
          label="Cidade *"
          onSearch={(search) =>
            fetchSelectOptions(`cities-by-province/${aggregation?.data?.province?.id}`, {
              search,
            })
          }
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={aggregation.data?.city}
          onChange={(value) => {
            aggregation.setData({ city: value });
            aggregation.setData({ city_id: value?.id });
          }}
          error={aggregation.errors?.['data.city_id']}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Toggle
          label="Status"
          value={aggregation.data?.active}
          onSelected={(value) => aggregation.setData({ active: value })}
          options={activeStatusOptions}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Toggle
          label="Apenas cavalo"
          value={aggregation.data?.main_unit_vehicle_only}
          onSelected={(value) => aggregation.setData({ main_unit_vehicle_only: value })}
          options={isVehicleTractionOptions}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Select
          label="Tipo de Veículo *"
          options={vehicleTypes}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={aggregation.data?.vehicleType}
          placeholder="Selecione"
          onChange={(value) => {
            aggregation.setData({ vehicleType: value });
            aggregation.setData({ vehicle_type_id: value?.id });
          }}
          error={aggregation.errors?.['data.vehicle_type_id']}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Select
          label="Tipo de Eixo *"
          options={axisList}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={aggregation.data?.veichleAxi}
          placeholder="Selecione"
          onChange={(value) => {
            aggregation.setData({ veichleAxi: value });
            aggregation.setData({ vehicle_axi_id: value?.id });
          }}
          error={aggregation.errors?.['data.vehicle_axi_id']}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Input
          type="number"
          label="Ano mínimo do veículo *"
          value={aggregation.data?.minimum_age}
          onChange={(event) => aggregation.setData({ minimum_age: event.target.value })}
          error={aggregation.errors?.['data.minimum_age']}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Select.Async
          label="Rastreador"
          onSearch={(search) => fetchSelectOptions('select/trackers', { search })}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={aggregation.data?.tracker}
          onChange={(value) => {
            aggregation.setData({ tracker: value });
            aggregation.setData({ tracker_id: value?.id });
          }}
        />
      </Col>
      <Col xs={6} className="mb-3">
        <Input
          type="number"
          label="Quantidade de Vagas *"
          value={aggregation.data?.quantity}
          onChange={(event) => aggregation.setData({ quantity: event.target.value })}
          min="1"
          error={aggregation.errors?.['data.quantity']}
        />
      </Col>
      <Col xs={12} className="mb-3">
        <TextArea
          label="Observações"
          value={aggregation.data?.observation}
          onChange={(event) => aggregation.setData({ observation: event.target.value })}
        />
      </Col>
    </Row>
  );
}
